// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"

require('../src/application.scss')
const images = require.context('../images/', true)
const imagePath = name => images(name, true)

Rails.start()

// ファイルアップロードの上限
window.UPLOAD_FILE_SIZE_LIMIT = 1024 * 1024 * 10;

import Cropper from 'cropperjs'

window.Cropper = Cropper
require('cropperjs/dist/cropper.min.css')
require('../src/rails/cropperjs_wrapper.scss')

import * as AutoKana from 'vanilla-autokana'
window.AutoKana = AutoKana

import Push from 'push.js'
window.Push = Push

var Trix = require("trix")
Trix.config.attachments.preview.caption = { name: false, size: false }
Trix.config.lang.bold = '太字'
Trix.config.lang.italic = '斜体'
Trix.config.lang.strike = '取り消し線'
Trix.config.lang.link = 'リンク'
Trix.config.lang.unlink = 'キャンセル'
Trix.config.lang.urlPlaceholder = 'URLを入力'
Trix.config.lang.heading1 = '見出し'
Trix.config.lang.quote = '引用'
Trix.config.lang.bullets = '箇条書き'
Trix.config.lang.numbers = '番号付き箇条書き'
Trix.config.lang.attachFiles = 'ファイルを添付'
Trix.config.lang.bold = '太字'

addEventListener('trix-file-accept', function(e) {
  if (e.file.type.indexOf('image') === -1) {
    e.preventDefault()
  }

  if (e.file.size > UPLOAD_FILE_SIZE_LIMIT) {
    e.preventDefault()
  }
})

require("@rails/actiontext")
import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')

$(document).ready(function () {
  if (isSignedIn) {
    var notificationLink = $('#js-read-more-notifications-link').get(0);
    if (notificationLink) {
      notificationLink.click();
    }

    // 通知許可を求めておく
    Push.Permission.request();

    setInterval(function () {
      var newlyLink = $('#js-check-newly-notifications-link').get(0);
      if (newlyLink) {
        newlyLink.click();
      }
    }, 10000);
  }

  $(document).on('click', '#js-global-search-button', function () {
    var button = $('#js-global-search-button');
    if (button.hasClass('-opened')) {
      button.removeClass('-opened');
    } else {
      button.addClass('-opened');
    }
  });

  $(document).on('mouseenter', 'ul#js-global-navi-list li', function () {
    $('#js-global-search-button').removeClass('-opened');
  });

  $(document).on('click', '#js-global-search-bg', function () {
    $('#js-global-search-button').removeClass('-opened');
  })

  $(document).on('click', '#js-global-menu-locales-button', function (e) {
    var list = $('#js-global-locale-list');
    if (list.hasClass('-opened')) {
      list.removeClass('-opened');
    } else {
      var buttonPosition = $(this).position();
      var listPosition = {
        left: buttonPosition.left,
        top: buttonPosition.top - list.outerHeight() + 48,
      };
      list.css(listPosition);
      list.addClass('-opened');
    }
    e.stopPropagation();
  });

  $(document).on('click', '#js-global-locale-button', function (e) {
    $('#js-global-mypage-list,#js-global-notification-list').removeClass('-opened');
    var list = $('#js-global-locale-list');
    if (list.hasClass('-opened')) {
      list.removeClass('-opened');
    } else {
      $('.p-languages-list').css({ top: '', left: '' });
      list.addClass('-opened');
    }
    e.stopPropagation();
  });

  $(document).on('click', '#js-global-mypage-button', function (e) {
    $('#js-global-locale-list,#js-global-notification-list').removeClass('-opened');
    var list = $('#js-global-mypage-list');
    if (list.hasClass('-opened')) {
      list.removeClass('-opened');
    } else {
      list.addClass('-opened');
    }
    e.stopPropagation();
  });

  $(document).on('click', '.js-global-notification-button', function (e) {
    $('#js-global-locale-list,#js-global-mypage-list').removeClass('-opened');
    var menu = $('#js-global-notification-list');
    if (menu.hasClass('-opened')) {
      menu.removeClass('-opened');
    } else {
      menu.addClass('-opened');
    }
    e.stopPropagation();
  });

  $(document).on('click', '#js-global-header-menu-button,#js-global-signed-in-header-menu-button', function () {
    var menu = $('#js-global-header-menu');
    if (menu.hasClass('-opened')) {
      menu.removeClass('-opened');
    } else {
      menu.addClass('-opened');
    }
  });

  $(document).on('click', '.js-global-links-list', function () {
    var that = $(this);
    if ($(window).width() <= 999) {
      if (that.hasClass('-opened')) {
        that.removeClass('-opened');
      } else {
        that.addClass('-opened');
      }
      return false;
    }
  });

  $(document).on('click', '#js-closable-popup', function () {
    $('#js-global-locale-list,#js-global-mypage-list,#js-global-notification-list').removeClass('-opened');
  });

  $('#js-global-header-menu').on('scroll', function () {
    $('#js-global-locale-list,#js-global-mypage-list,#js-global-notification-list').removeClass('-opened');
  });

  setTimeout(function () {
    $('#js-header-notice').fadeOut(500);
  }, 10000);

  $(document).on('click', '#js-header-notice-close-button', function () {
    $('#js-header-notice').fadeOut(500);
  });
});
